import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../../app/i18n";
import { PayResultPage } from "../../../areas/public/pay/PayResultPage";

export interface PayResultSearch {
  session?: string;
}

/** Card payment result (FE-13 FR-FE13-13): the gateway returns here with `?session=`. */
export const Route = createFileRoute("/pay/result/$ref")({
  validateSearch: (search: Record<string, unknown>): PayResultSearch => {
    const session = search.session;
    return typeof session === "string" && session.length > 0 && session.length <= 200
      ? { session }
      : {};
  },
  beforeLoad: () => loadNamespaces("pay"),
  component: PayResultRoute,
});

function PayResultRoute() {
  const { ref } = Route.useParams();
  const { session } = Route.useSearch();
  return <PayResultPage reference={ref} session={session} />;
}
